/**
 * Card-related constants and utilities
 * Extracted from streetactions.ts for better organization
 */

import type { Suit, Value } from 'pokersolver'

/**
 * Face card values (non-numeric cards)
 */
export enum FACE_CARD_VALUES {
  J = 'J',
  Q = 'Q',
  K = 'K',
  A = 'A'
}

export const Suits: Suit[] = ['c', 'd', 'h', 's']
export const Values: Value[] = ['2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K', 'A']

/**
 * Array of all face cards
 */
export const FACE_CARDS = [FACE_CARD_VALUES.J, FACE_CARD_VALUES.Q, FACE_CARD_VALUES.K, FACE_CARD_VALUES.A]

/**
 * Special suited connector combinations
 * These are high-value suited connectors (e.g., A-K suited, K-Q suited)
 */
export const SPECIAL_SUITED_CONNECTORS_VALUES: [Value, Value][] = [
  ['9', 'T'],
  ['T', 'J'],
  ['J', 'Q'],
  ['Q', 'K'],
  ['K', 'A'],
  ['A', '2']
]
